// Shows `admin` to an admin and `fallback` to every other role, deciding by
// the role active *now*. A role check written straight into App's route JSX
// only runs on App's first render, so after a login or role switch without
// a page reload it kept showing the non-admin page.
import { useAuth } from "../contexts/AuthContext";

export default function AdminOrDefault({ admin, fallback }) {
  const { user } = useAuth();
  const role = user?.role || localStorage.getItem("role");
  return role === "admin" ? admin : fallback;
}
